import { Browser } from '@capacitor/browser';

export const openBrowser = async (url?: string) => {
  if (url) {
    await Browser.open({ url, presentationStyle: 'popover', windowName: '_blank' });
  }
};
